import { Info, MoreVert } from "@mui/icons-material"
import { FormControlLabel, IconButton, Menu, MenuItem, Switch, Tooltip } from "@mui/material"
import { ChangeEvent, MouseEvent, useState } from "react"
import { useLocalStorage } from "usehooks-ts"

export const CLOSE_NODE_DRAWER_ON_SAVE_LS_KEY = "builder-page-close-drawer-on-save"
export const CLOSE_NODE_DRAWER_ON_BLUR_LS_KEY = "builder-page-close-drawer-on-blur"
export const CLOSE_NODE_DRAWER_ON_MULTISELECT_LS_KEY = "builder-page-close-drawer-on-multiselect"

const NodeDrawerOptionsMenu = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const [closeOnSave, setCloseOnSave] = useLocalStorage(CLOSE_NODE_DRAWER_ON_SAVE_LS_KEY, false)
  const [closeOnBlur, setCloseOnBlur] = useLocalStorage(CLOSE_NODE_DRAWER_ON_BLUR_LS_KEY, true)
  const [closeOnMultiselect, setCloseOnMultiselect] = useLocalStorage(
    CLOSE_NODE_DRAWER_ON_MULTISELECT_LS_KEY,
    true,
  )

  const isOpen = Boolean(anchorEl)

  const handleOpenClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleCloseOnSaveChange = (event: ChangeEvent<HTMLInputElement>) => {
    setCloseOnSave(event.target.checked)
  }

  const handleCloseOnBlur = (event: ChangeEvent<HTMLInputElement>) => {
    setCloseOnBlur(event.target.checked)
  }

  const handleCloseOnMultiselect = (event: ChangeEvent<HTMLInputElement>) => {
    setCloseOnMultiselect(event.target.checked)
  }

  return (
    <>
      <Tooltip title="Options">
        <IconButton onClick={handleOpenClick} sx={{ p: 0 }}>
          <MoreVert />
        </IconButton>
      </Tooltip>

      <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose}>
        <MenuItem>
          <FormControlLabel
            control={
              <>
                <Switch checked={closeOnSave} onChange={handleCloseOnSaveChange} />
                <Tooltip title="Controls whether node drawer should auomtiacally close after you save changes that were made">
                  <Info color="disabled" sx={{ mr: 1 }} />
                </Tooltip>
              </>
            }
            label="Close on save"
          />
        </MenuItem>
        <MenuItem>
          <FormControlLabel
            control={
              <>
                <Switch checked={closeOnBlur} onChange={handleCloseOnBlur} />
                <Tooltip title="Controls whether node drawer should be closed once you click on the blank area of the graph builder. If your drawer has unsaved changes, you would still need to confirm closing it.">
                  <Info color="disabled" sx={{ mr: 1 }} />
                </Tooltip>
              </>
            }
            label="Close on graph blank area click"
          />
        </MenuItem>
        <MenuItem>
          <FormControlLabel
            control={
              <>
                <Switch checked={closeOnMultiselect} onChange={handleCloseOnMultiselect} />
                <Tooltip title="Controls whether node drawer should be closed once you select more than 1 node.">
                  <Info color="disabled" sx={{ mr: 1 }} />
                </Tooltip>
              </>
            }
            label="Close on multiselection"
          />
        </MenuItem>
      </Menu>
    </>
  )
}

export default NodeDrawerOptionsMenu
